module.exports = __webpack_public_path__ + "img/hutaomu1.08622382.jpg";